import { render, staticRenderFns } from "./short-answer.vue?vue&type=template&id=1f3284fb&scoped=true"
import script from "./short-answer.vue?vue&type=script&lang=js"
export * from "./short-answer.vue?vue&type=script&lang=js"
import style1 from "./short-answer.vue?vue&type=style&index=1&id=1f3284fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3284fb",
  null
  
)

export default component.exports